export default (timestamp: number | Date, milliseconds: number): Date => new Date(+timestamp + milliseconds);
